import React from "react";

const Left = ({ charity }) => {
	return (
		<div>
			<h3>
				Thank you for your support of the Valero Texas Open’s Champions{" "}
				<i>fore</i> Charity fundraising program!
			</h3>

			<p style={{ marginBottom: "0" }}>
				Guess who the 2026 Valero Texas Open Champion will be from this year’s
				player field.
			</p>

			<ul style={{ marginTop: "15px", marginBottom: "0" }}>
				<li>
					NOTE: You have until{" "}
					<strong>Wednesday, April 1 at 11:59 pm CT</strong> to select from the
					player field who you think will win the Valero Texas Open.
				</li>
				<li>
					Careful - Once you submit your guess you will <strong>NOT</strong> be
					able to adjust your selection.
				</li>
			</ul>

			<p style={{ marginBottom: "5px" }}>
				The winner will be drawn from those who correctly guessed the tournament
				champion and receive the grand prize, along with earning{" "}
				<strong>{charity}</strong> a donation of $5,000.
			</p>

			<p style={{ marginBottom: "0" }}>
				Thank you again for your support. Good luck on guessing who you think
				will win this year’s Valero Texas Open!
			</p>
		</div>
	);
};

export default Left;
